export default __webpack_public_path__ + "static/media/horse.5ac65e77.svg";